import { render, staticRenderFns } from "./FirstBookHistoryCoveragePanel.vue?vue&type=template&id=53922c89&scoped=true&"
import script from "./FirstBookHistoryCoveragePanel.vue?vue&type=script&lang=js&"
export * from "./FirstBookHistoryCoveragePanel.vue?vue&type=script&lang=js&"
import style0 from "./FirstBookHistoryCoveragePanel.vue?vue&type=style&index=0&id=53922c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53922c89",
  null
  
)

export default component.exports